module.exports = __webpack_public_path__ + "clinic.46d2ffab50734f38d0bb.ttf";


//////////////////
// WEBPACK FOOTER
// D:/My Projects/2023/eCompound/unimas-request-web/src/assets/fonts/clinic.ttf
// module id = ../../../../../src/assets/fonts/clinic.ttf
// module chunks = styles